<template>
    <div class="login flex-n fac fjc">
        <div class="login_bg">
            <img class="login_download" :src="url">
            <div class="download_text">APP下载</div>
            <div class="login_content">
                <img class="logo" src="../common/images/logo.png" alt="">
                <div class="title mt-10">刺兔预定管理系统</div>
                <el-form :model="data" :rules="rules" ref="ruleForm" class="rulefrom mt-20" label-width="0">
                    <el-form-item label="" prop="loginName">
                        <el-input maxlength="32" class="w-200 login_input" v-model="data.loginName" placeholder="请输入用户名"
                                  @keyup.enter.native="submitForm('ruleForm')">
                            <div slot="prepend">
                                <i class="el-icon-user fs-20"></i>
                            </div>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="" prop="passWord">
                        <el-input type="password" maxlength="18" class="w-200 login_input" v-model="data.passWord"
                                  placeholder="请输入密码" @keyup.enter.native="submitForm('ruleForm')">
                            <div slot="prepend">
                                <i class="el-icon-lock fs-20"></i>
                            </div>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="mt-10 flex-n fjc">
                        <div @click="submitForm('ruleForm')" class="login_btn" v-pointer>登录</div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <a href="https://beian.miit.gov.cn/" class="filing_text">辽ICP备12009242号-4
        </a>
    </div>
</template>

<script>


    export default {
        components: {},
        name: "login",
        data() {
            return {
                data: {
                    loginName: '',
                    passWord: ''
                },
                rules: {
                    passWord: [{required: true, message: '密码不能为空', trigger: 'blur'}],
                    loginName: [{required: true, message: '用户名不能为空', trigger: 'blur'}],
                },
                url:''
            }
        },
        mounted(){
          this.getDownloadUrl();
        },
        methods: {

            getDownloadUrl(){
                this.$axios.get('/product/getLastVersion').then(res=>{
                    console.log(res.data)
                    this.url=res.data.list[0].QRCodeImage;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post('/account/login', {
                            loginName: this.data.loginName,
                            passWord: this.data.passWord
                        }).then(res => {
                            console.log(res)
                            this.$message.success('登录成功');
                            this.$root.setStorage('login', true);
                            this.$store.state.dicChange = true;
                            // this.getMenu();
                            this.$root.setStorage('authorization', res.data.Authorization);
                            this.$root.setStorage('info', res.data);
                            this.$root.setStorage('storeId', res.data.storeId);
                            this.getMenuState();
                            this.$router.replace('/index')
                        }).catch(err => {
                            console.log(err)
                            this.$message.error(err.msg);
                        })
                    } else {
                        return false;
                    }
                });
            },
            getMenuState(){
                this.$axios.post("storeAuth/findByRoleIdStoreId",{
                    "roleId": this.$root.getStorage('info').roleId,
                    "storeId": this.$root.getStorage('storeId')
                }).then(res=>{
                    console.log(res.data)
                    this.$root.setStorage('menuAuth',res.data.auth)
                }).catch(err=>{
                    this.$message.error(err.msg)
                })
            },
            //
            // getMenu() {
            //     this.$axios.get('/menu/menuRecurrenceUser/1/1').then(res => {
            //         console.log('动态菜单获取', res.data);
            //         this.$root.setStorage('menuList', res.data.children)
            //     }).catch(err => {
            //         this.$message.error(err.msg)
            //     })
            // },
        }
    }
</script>

<style scoped lang="scss">
    .login {
        width: 100%;
        height: 100%;
        background-image: url("../../src/common/images/bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        text-align: center;
        position: relative;
        .filing_text{
            position: absolute;
            bottom:10px;
            color:#aaa;
            text-decoration: none;
        }
        .login_bg {
            background-image: url("../../src/common/images/bg2.png");
            width: 600px;
            height: 350px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;
            .download_text{
                position: absolute;
                left: 50px;
                top:235px;
                width: 150px;
                text-align: center;
                color: white;
            }
            .login_download{
                width: 150px;
                height: 150px;
                position: absolute;
                left: 50px;
                top:80px;
            }
            .login_content {
                width: 300px;
                margin-left: 300px;

            }
        }
        .logo {
            width: 55px;
            margin-top: 35px;
            border-radius: 25px;
            box-shadow: 0 5px 10px #97bff1;

        }
        .title {
            font-weight: 700;
            font-size: 16px;
            color: #333333;
            text-align: center;
        }
        .login_input {
            margin-left: -10px;
        }
        .login_btn {
            width: 200px;
            height: 25px;
            color: white;
            line-height: 25px !important;
            background: linear-gradient(90deg, rgba(9, 95, 255, 1), rgba(9, 95, 255, 1));
            box-shadow: 0px 2px 13px 0px rgba(50, 129, 255, 0.51);
            border-radius: 1px;
        }
    }
</style>